import React from 'react';

/*
    - ihoDesignSystem
*/
import { Grid, TextField } from '@iho-design-system/Loader';

/*
    - icon
*/
import SearchSVG from '../../assets/images/icons/search.svg';

const Toolbar = ({ hotelNameSaerchPrps }) => {

    /*
        -defaultData
    */
    const [hotelNameSearchKey, setHotelNameSearchKey] = React.useState('');

    /*
        - searchProps
    */
    const search = (value) => {
        setHotelNameSearchKey(value)
        hotelNameSaerchPrps(value);
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12 lg-4 md-6'>
                        <TextField
                            onChange={search}
                            placeholder='جستجو بر اساس نام هتل'
                            icon={SearchSVG}
                            value={hotelNameSearchKey} />
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Toolbar;